<template>
  <router-view />
</template>

<script>
export default {
  name: 'SafariGroupsIndex'
}
</script>
